import {string, shape, number} from 'prop-types';

const AnimalTypeResourceType = {
  label: string,
  data: shape({
    id: number,
    label: string,
    image: string,
    type: string,
  }),
};

export default AnimalTypeResourceType;
